// extracted by mini-css-extract-plugin
export default {"Box":"CodeViewError-module__Box__hQizCb5"};